module.exports = __webpack_public_path__ + "src/assets/img/atech.08b9a45a.jpg";